import React from "react";
const PostSummaryItem = (
    {
      post ={
        "topic": "Web Development",
        "userName": "ReactJS",
        "time": "2h",
        "title": "React.js is a component based front end library that makes it very easy to build Single Page Applications or SPAs",
        "image": "/images/react.png"
      }
    }) => {
    return(
        <div>
          <div className={`row`}>
            <div className={`col`}>
              <div className={`container`}>
                <div className={`card`}>
                  <div className={`wd-pl-16 row card-body`}>
                    <div className={`col`}>
                    <h5 className={`card-title lh-1 wd-lightgray ws-font-15 text-white`}>{post.topic}</h5>
                    <p className={`card-text lh-1 wd-black wd-font-15 wd-bold text-white`}>{post.userName}<i className={`fas fa-check-circle`}></i><span className={`wd-gray`}> - {post.time}</span></p>
                    <p className={`card-text lh-1 wd-black wd-font-15 wd-bold text-white`}>{post.title}</p>
                    </div>
                    <div className={`col-3`}>
                      <div className={`card`}>
                        <img src={post.image} alt={'post_logo'} className="card-img"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  );
}

export default PostSummaryItem;
